





































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NeedLoginModal extends Vue {
  @Prop({ default: false }) pReverse!: boolean;
  @Prop({ default: true }) pPersistentMode!: boolean;

  dialog = false;

  open() {
    this.dialog = true;
  }
}
